// Centralized hourly rates per region / year
// TODO: Implement dynamic update (fetch from convenio data source or allow admin updates)
// For now we include a hard-coded value for Aragón 2025 required by the PR.
export const ARAGON_2025_HOURLY = 13.18;

type RegionKey = string | undefined;

// Map of [regionCode]-[year] -> hourly rate. Region codes follow the values used in the UI
const REGION_HOURLY_RATES: Record<string, number> = {
  // Aragon (AR) 2025
  'AR-2025': ARAGON_2025_HOURLY,
};

export function getRegionHourlyRate(region?: RegionKey, year = 2025): number {
  const key = `${region ?? 'NATIONAL'}-${year}`;
  // fallback: if region-specific not found, return a sensible default (use Aragon 2025 for now)
  return REGION_HOURLY_RATES[key] ?? ARAGON_2025_HOURLY;
}

/**
 * Calculate national holiday surcharge (festivo nacional) for a given region and year.
 * Formula: hourly rate × 8 hours × 0.75 (75% of a standard workday).
 * Currently uses the same rate for all regions (Aragon 2025 baseline).
 *
 * @param region - Optional region code (e.g., 'AR', 'GA')
 * @param year - Year for the calculation (default: 2025)
 * @returns National holiday surcharge in EUR, rounded to 2 decimals
 */
export function getFestivoNacionalPrice(_region?: RegionKey, _year = 2025): number {
  // For national holidays, use the standard Aragon hourly rate (13.18 EUR)
  // This applies uniformly across all regions as per business rules
  const hourly = ARAGON_2025_HOURLY;
  const horasFestivo = 8;
  const percentage = 0.75;
  return Math.round(hourly * horasFestivo * percentage * 100) / 100;
}

export default { ARAGON_2025_HOURLY, getRegionHourlyRate, getFestivoNacionalPrice };
